import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import S from "string";
//constants
import { usStates } from "../../../../constants/app";
//utils
import { renderField, renderSelectField } from "../../../../utils/forms";
//antd
import { Button, Col, Row } from "antd";

const fields = ["name", "pc_first_name", "pc_last_name", "pc_email", "status"];

const statusOptions = [
  { text: "Approved", value: "approved" },
  { text: "On-boarding", value: "on-boarding" },
  { text: "Declined", value: "declined" }
];

const companyGoalsOptions = [
  { value: 'Attract More Qualified MBA Candidates', text: 'Attract More Qualified MBA Candidates' },
  { value: 'Build More Diverse Talent Pipeline', text: 'Build More Diverse Talent Pipeline' },
  { value: 'Solve a Real Business Challenge', text: 'Solve a Real Business Challenge' },
  { value: 'Improve Employment Brand and Engagement', text: 'Improve Employment Brand and Engagement' },
];

const validate = values => {
  const errors = {};
  fields.forEach(field => {
    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }
  });
  return errors;
};

export class ClientForm extends Component {
  state = {
    deleting: false
  };

  constructor(props) {
    super(props);
  }

  _delete = () => {
    const { deleteCompanyUser } = this.props;
    let confirmDelete = window.confirm("Confirm Delete User");
    if (confirmDelete) {
      this.setState({
        deleting: true
      });
      deleteCompanyUser();
    }
  };

  render() {
    const { handleSubmit, backToCompany, companies, searchCompanies } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Row type="flex" justify="center">
          <Col span={4}>
            <Field
              name="status"
              type="text"
              component={renderSelectField}
              label="Status"
              options={statusOptions}
            />
          </Col>
        </Row>
        <div style={{ height: "30px" }} />
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="First Name"
              label="First Name"
              name="first_name"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              placeholder="Last Name"
              label="Last Name"
              name="last_name"
              component={renderField}
              type="text"
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="Title"
              label="Title"
              name="title"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              placeholder="Company"
              label="Company"
              name="company_id"
              component={renderSelectField}
              options={companies}
              onSearch={searchCompanies}
              defaultActiveFirstOption={false}
              filterOption={false}
              type="text"
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="Phone #"
              label="Phone #"
              name="phone"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              name="email"
              type="text"
              component={renderField}
              label="Email"
              placeholder="Email"
              options={usStates}
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="LinkedIn Url"
              label="LinkedIn Url"
              name="linkedin_url"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              name="interests"
              type="text"
              component={renderSelectField}
              label="Interests"
              placeholder="Interests"
              options={companyGoalsOptions}
              multi={true}
            />
          </Col>
        </Row>
        <Row type="flex" justify="center">
          <Col md={12}>
            {this.state.deleting ? <div>Deleting...</div> : (
              <Fragment>
                <Button style={{ width: "30%" }} type="primary" htmlType="submit">
                  Update User
                </Button>
                <Button style={{ width: "30%", marginLeft: "5px" }} onClick={this._delete} type="danger">
                  Delete User
                </Button>
                <Button style={{ width: "30%", marginLeft: "5px" }} onClick={backToCompany} >
                  Back to Company
                </Button>
              </Fragment>
            )}
          </Col>
        </Row>
      </form>
    );
  }
};

export default reduxForm({
  form: "client-edit",
  validate
})(ClientForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/forms/client.js